import request from '../../axios';

interface IBrandDetail {
  guid: string;
  id: number;
  logo: string;
  name: string;
  priority: number;
  store: string;
}

export const getBrandDetailById = async (brandId?: string) => {
  const {data}: {data: IBrandDetail} = await request.get(
    `/api/v2/warehouse/detail-brand/` + brandId,
  );

  return data;
};
